import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import Head from '../head';
import Feed from '../feed';
import styles from './index.css';

class Column1 extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            columnHead3,
            columnFeed3
        } = this.props.content;

        return (
            <div className={styles.column2}>
                <Chip id="261100" type="struct" title="图集标题" groupName="图集" content={columnHead3} >
                    <Head />
                </Chip>
                <Chip id="289141" type="recommend" title="图集标题推荐位" groupName="图集" content={columnFeed3} >
                    <Feed />
                </Chip>
            </div>
        );
    }
}

export default Column1;
